import { useEffect, useState } from 'react';
import fetch from '../../../Api/definitionSelectJobTitle';

const useJobTitle = setIsLoading => {
  const [jobTitle, setJobTitle] = useState([]);
  useEffect(() => {
    fetch().then(data => {
      setJobTitle(data.jobTitleList);
      setIsLoading(false);
    });
  }, []);

  return {
    jobTitle,
    setJobTitle,
  };
};

export default useJobTitle;
